import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'
// core components
import GridContainer from '../Grid/GridContainer.jsx'
import GridItem from '../Grid/GridItem.jsx'
import Button from '../CustomButtons/Button.jsx'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import config from '../../../data/SiteConfig'

import {
  FaTwitter,
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaLinkedin,
  FaTelegramPlane,
} from 'react-icons/fa'

import styles from '../../assets/jss/material-kit-pro-react/views/componentsSections/preFooter.jsx'

const SectionPreFooter = props => {
  const { classes } = props
  return (
    <div
      className={classNames(
        classes.socialLine,
        classes.textCenter,
        classes.cyan,
        classes.bigIcons
      )}
    >
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={1} md={1} className={classes.border}>
            <Button
              color="white"
              justIcon
              simple
              href={config.socialMediaLinks.telegram}
              target="_blank"
            >
              <FaTelegramPlane color="black" />
            </Button>
          </GridItem>
          <GridItem xs={12} sm={1} md={1} className={classes.border}>
            <Button
              color="white"
              justIcon
              simple
              href={config.socialMediaLinks.linkedin}
              target="_blank"
            >
              <FaLinkedin color="black" />
            </Button>
          </GridItem>
          <GridItem xs={12} sm={1} md={1} className={classes.border}>
            <Button
              color="white"
              justIcon
              simple
              href={config.socialMediaLinks.instagram}
              target="_blank"
            >
              <FaInstagram color="black" />
            </Button>
          </GridItem>
          <GridItem xs={12} sm={1} md={1} className={classes.border}>
            <Button
              color="white"
              justIcon
              simple
              href={config.socialMediaLinks.youtube}
              target="_blank"
            >
              <FaYoutube color="black" />
            </Button>
          </GridItem>
          <GridItem xs={12} sm={1} md={1} className={classes.border}>
            <Button
              color="white"
              justIcon
              simple
              href={config.socialMediaLinks.facebook}
              target="_blank"
            >
              <FaFacebook color="black" />
            </Button>
          </GridItem>
          <GridItem xs={12} sm={1} md={1} className={classes.border}>
            <Button
              color="white"
              justIcon
              simple
              href={config.socialMediaLinks.twitter}
              target="_blank"
            >
              <FaTwitter color="black" />
            </Button>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  )
}

export default withStyles(styles)(SectionPreFooter)



// WEBPACK FOOTER //
// ./src/components/Footer/PreFooter.jsx